// extracted by mini-css-extract-plugin
export default {"cta":"IF-z","disabled":"JF-z"};